import React, { Component } from 'react'
import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import moment from 'moment';

class DateInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.props.date
        };
    }
    render() {
        return (
            <div className="DateBox" style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                <IconButton className="navigation" onClick={() => this.decrementDate(this.state.date)} iconClassName="material-icons">
                    navigate_before
                </IconButton>
                <DatePicker
                    name='gameDate'
                    className="DateInput"
                    floatingLabelText="Date"
                    autoOk={true}
                    value={this.state.date}
                    onChange={(event, date) => this.onInputChange(date)} />
                <IconButton className="navigation" onClick={() => this.incrementDate(this.state.date)} iconClassName="material-icons">
                    navigate_next
                </IconButton>
            </div>
        )
    }
    onInputChange(date) {
        this.setState({ date });
        this.props.onDateChange(date);
    }
    incrementDate(date) {
        date = moment(date).add(1, 'day')._d;
        this.props.onDateChange(date);
        this.setState({ date })
    }
    decrementDate(date) {
        date = moment(date).subtract(1, 'day')._d;
        this.props.onDateChange(date);
        this.setState({ date })
    }
}
export default DateInput


// WEBPACK FOOTER //
// ./src/components/date_picker.jsx